module.exports = __webpack_public_path__ + "assets/images/star-rating.icons.svg";


//////////////////
// WEBPACK FOOTER
// ./~/css-star-rating/dist/images/star-rating.icons.svg
// module id = 10
// module chunks = 0